module.exports = __webpack_public_path__ + "static/creating-powerful-radio-79bae82fd6c9bf8677d7a88abb1f6508.jpg";